module.exports = __webpack_public_path__ + "static/media/medal.baaa26ec.svg";